<template>
  <div
    ref="itemsWrapper"
    class="ten-time-options"
    @mouseenter="$listeners.mouseenter"
  >
    <div ref="itemsWrapperScrollElm">
      <span
        v-for="(item, index) in optionList"
        :key="index"
        :class="['ten-time-options__item', {
          'ten-time-options__item--selected': item.selected,
          'ten-time-options__item--disabled': item.disabled
        }]"
        @click="onClickHandler(item.disabled, item.value)"
      >
        {{ item.text }}
      </span>
    </div>
  </div>
</template>

<script>
import { easeout } from '../util';

const itemHeight = 40;

export default {
  inject: {
    picker: {
      from: 'picker',
    },
    dateTime: {
      from: 'dateTime',
      default: {},
    },
  },
  props: {
    optionList: Array,
    topItemIndex: Number,
  },
  watch: {
    'picker.popupShow': {
      handler() {
        this.fixScrollBarshake();
        this.scrollTo(this.topItemIndex, 0);
      },
    },
    'dateTime.showTime': {
      handler() {
        this.fixScrollBarshake();
        this.scrollTo(this.topItemIndex, 0);
      },
    },
  },
  mounted() {
    this.fixScrollBarshake();
    this.scrollTo(this.topItemIndex);
  },
  updated() {
    this.scrollTo(this.topItemIndex);
  },
  methods: {
    onClickHandler(disabled, value) {
      if (disabled) return;
      this.$emit('change', value);
    },
    fixScrollBarshake() {
      setTimeout(() => {
        if (this.$refs.itemsWrapper) {
          const { width } = this.$refs.itemsWrapper.getBoundingClientRect();
          if (width) {
            this.$refs.itemsWrapper.style.width = `${width}px`;
            this.$refs.itemsWrapperScrollElm.style.width = `${width}px`;
          }
        }
      });
    },
    scrollTo(index, rate = 4) {
      const start = this.$el.scrollTop;
      const end = (itemHeight * index) + 1;

      if (this.$el) {
        if (rate === 0) {
          setTimeout(() => {
            this.$el.scrollTop = end;
          });
          return;
        }
        this.$nextTick(() => {
          if (start !== end) {
            this.$el.classList.add('ten-time-options--scrolling');
          }
          this.$el.scrollTop = start;
          this.$nextTick(() => {
            this.$el.scrollTop = start;
            easeout(start, end, rate, (value, isFinished) => {
              this.$el.scrollTop = value;
              if (isFinished) {
                setTimeout(() => {
                  this.$el.classList.remove('ten-time-options--scrolling');
                });
              }
            });
          });
        });
      }
    },
  },
};
</script>
